import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Styles from "./index.module.scss";
import clsx from "clsx";
import "dayjs/locale/vi";

export const DatePickerCustom = ({
  id,
  openTo,
  variant,
  views,
  label,
  helpText,
  handleSetYear,
  handleSetMonth,
}) => {
  const current = dayjs().startOf("month");
  const handleDateChange = (value) => {
    if (value && !isNaN(value.year()) && !isNaN(value.month())) {
      handleSetMonth(value.month() + 1);
      handleSetYear(value.year());
    }
  };
  return (
    <div className={clsx(Styles.wrapBox)}>
      <label className={clsx(Styles.label)} htmlFor={id}>
        {label}
      </label>
      <div className={clsx(Styles.dateTime)}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
          <DatePicker
            variant={variant}
            openTo={openTo}
            views={["year", "month"]}
            helperText={helpText}
            value={current}
            onChange={handleDateChange}
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                borderRadius: 0,
              },
              "& .MuiOutlinedInput-input": {
                padding: " 15px 5px",
                textTransform: "capitalize",
              },
            }}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};
